import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type KnowledgeBase } from "./types";

export default {
  init: (apiInfo: ModuleApiInfo): Promise<HttpApiResponse<KnowledgeBase.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/kb`),
  getContent: (apiInfo: ModuleApiInfo, articleId: string): Promise<HttpApiResponse<string>> =>
    api.get(apiInfo, `/api/site/v1/modules/kb/articles/${articleId}/content`)
};
